/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { create } from 'zustand';
import { AuthService, EntityAuth } from '../Services/auth';

/**
 * The definition of state-controlled settings for the auth service.
 */
export interface AuthServiceStore {
  authService: AuthService | null;
  authUser: EntityAuth | null;
  updateAuthService: (newValue: AuthService | null) => void;
  updateAuthUser: (newValue: EntityAuth | null) => void;
}

/**
 * The state store for the auth service.
 */
export const useAuthServiceStore = create<AuthServiceStore>()((set) => ({
  authService: null,
  authUser: null,
  updateAuthService: (newValue: AuthService | null): void => {
    set({ authService: newValue });
  },
  updateAuthUser: (newValue: EntityAuth | null): void => {
    set({ authUser: newValue });
  },
}));
